import { Box, useToast } from '@chakra-ui/react';
import * as Sentry from '@sentry/react';
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import {
  errorToastConfig,
  errorToastId,
} from 'packages/common-frontend/constants';
import 'source/borrower/borrower.scss';
import { Assignment } from 'valleyBank/domains/Assignment/ui/Assignment';
import { useDataMetadataContext } from 'valleyBank/domains/page/hooks/DataMetadataContext';

export const AssignmentRoute = () => {
  const toast = useToast();
  const history = useHistory();
  const { dashboardMode } = useDataMetadataContext();

  useEffect(() => {
    if (dashboardMode !== 'current') {
      history.push('/');
    }
  }, [history, dashboardMode]);

  let routeLevelError = false;
  return (
    <Box>
      <Sentry.ErrorBoundary
        onError={() => {
          if (!routeLevelError && !toast.isActive(errorToastId)) {
            errorToastConfig.title = `Failed to load assignments page`;
            routeLevelError = true;
            toast(errorToastConfig);
            history.push('/');
          }
        }}
      >
        <Assignment />
      </Sentry.ErrorBoundary>
    </Box>
  );
};
